/**
 * Cross-portal (shared chrome) messages — German. This is the **reference
 * language**: its shape (`Messages`) is what every other language file is
 * type-checked against, so add new keys here first.
 *
 * Area-specific strings live in the respective area's `i18n/` folder.
 */
const de = {
  login: {
    welcomeBack: 'Willkommen zurück',
    customerPortal: 'Kundenportal',
    lead: 'Melden Sie sich bei Ihrem Kundenkonto an.',
    username: 'Benutzername',
    password: 'Passwort',
    forgotPassword: 'Vergessen?',
    signingIn: 'Anmeldung läuft…',
    signIn: 'Anmelden',
    notCustomerYet: 'Noch kein Kunde?',
    requestAccess: 'Zugang anfordern →',
    brandTag: 'Factory Innovation Award 2023–2025',
    headline: 'Ein Portal für Tickets, Lizenzen, Downloads und Abrechnung.',
    subline: 'Alles, was Sie benötigen, um software4production an Ihren Standorten zu betreiben – an einem Ort, immer aktuell.',
    imprint: 'Impressum',
    privacy: 'Datenschutz',
    errorInvalidCredentials: 'Ungültiger Benutzername oder Passwort',
    errorGeneric: 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  },
  session: {
    expiredHeader: 'Sitzung abgelaufen',
    expiredMessage: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
    toLogin: 'Zur Anmeldung',
  },
  language: {
    label: 'Sprache',
    de: 'Deutsch',
    en: 'Englisch',
  },
  appShell: {
    profile: 'Profil',
    signOut: 'Abmelden',
    help: 'Hilfe',
    notifications: 'Benachrichtigungen',
    toggleSidebar: 'Seitenleiste ein-/ausblenden',
  },
};

export type Messages = typeof de;
export default de;
